module.exports = __webpack_public_path__ + "static/media/BrandsIcon.97d99e1d.svg";